import { MyProvider } from './MyContext';
import MyRoutes from './MyRoutes';

function App() {
    return (
        <MyProvider>
            <MyRoutes />
        </MyProvider>
    );
}

export default App;

